// extracted by mini-css-extract-plugin
export default {"errorContainer":"styles_errorContainer__FBoh2","errorText":"styles_errorText__zP5br"};